export function getBootstrapDeviceSize() {
    if (window.getComputedStyle(document.getElementById('xl-up')).display !== 'none') {
        return 'xl';
    } else if (window.getComputedStyle(document.getElementById('lg-up')).display !== 'none') {
        return 'lg';
    } else if (window.getComputedStyle(document.getElementById('md-up')).display !== 'none') {
        return 'md';
    } else if (window.getComputedStyle(document.getElementById('sm-up')).display !== 'none') {
        return 'sm';
    } else {
        return 'xs';
    }
}